import { useEffect, useState } from 'react'
import { doc, getDoc } from 'firebase/firestore/lite'
import { db } from '../lib/firebase'
import { useSesion } from './useSesion'

/**
 * Rol de admin del usuario actual, leído de `admins/{uid}` (ver
 * firestore.rules: cada quien solo puede leer su propio doc ahí). Esto solo
 * decide qué se muestra en el panel — la autorización real vive en las
 * Cloud Functions (exigirAdmin/exigirSuperadmin en functions/index.js).
 */
export function useEsAdmin() {
  const { usuario } = useSesion()
  const [rol, setRol] = useState(null)
  const [cargando, setCargando] = useState(true)

  useEffect(() => {
    if (!usuario) {
      setRol(null)
      setCargando(false)
      return
    }

    let vigente = true
    setCargando(true)

    getDoc(doc(db, 'admins', usuario.uid))
      .then((snap) => {
        if (!vigente) return
        setRol(snap.exists() ? snap.data().rol : null)
      })
      .catch((err) => {
        console.error('useEsAdmin:', err)
        if (vigente) setRol(null)
      })
      .finally(() => {
        if (vigente) setCargando(false)
      })

    return () => {
      vigente = false
    }
  }, [usuario])

  return {
    rol,
    esAdmin: rol === 'admin' || rol === 'superadmin',
    esSuperadmin: rol === 'superadmin',
    cargando,
  }
}
